import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { Footer } from '../../../../../../../../components/atoms/Footer/Footer';
import { AwaitingScenario } from '../../../../../../../../models/credentials';
import { ProviderEntity } from '../../../../../../../../models/provider';
import { H1 } from '../../../../../../../../components/atoms/Heading/Heading';
import { ContentBody } from '../../../../../../../../components/atoms/ContentBody/ContentBody';
import { Button } from '../../../../../../../../components/atoms/Button/Button';
import { ScreenWrapper } from '../../../../../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { LoadingSpinner } from '../../../../../../../../components/atoms/LoadingSpinner/LoadingSpinner';
import { BankIdLogo } from '../../../../../../../../components/atoms/BankIdLogo/BankIdLogo';
import { LegalDisclaimer } from '../../../../../../../../components/molecules/LegalDisclaimer/LegalDisclaimer';
import { Header } from '../../../../../../../../components/organisms/Header/Header';
import { messages as AwaitingMessages } from '../../../../../../../../components/screens/AwaitingCredentialsScreen/organisms/AwaitingMobileBankIdAuthenticationContainer/molecules/AwaitingMobileBankIdAuthenticationTarget/messages';
import { StyledBankId } from '../../../../../../../../components/screens/AwaitingCredentialsScreen/organisms/AwaitingMobileBankIdAuthenticationContainer/molecules/AwaitingMobileBankIdAuthenticationTarget/AwaitingMobileBankIdAuthenticationTarget.styles';
import { PageView } from '../../../../../../../../models/analytics';
import { Stack } from '../../../../../../../../components/atoms/Stack/Stack';

export type MobileViewProps = {
  provider: ProviderEntity;
  onBack: () => void;
  onClickLocal: () => void;
  onClickRemote: () => void;
  isLoading: boolean;
  awaitingScenario: AwaitingScenario;
  paymentDetails?: React.ReactNode;
};

export const SubmitCredentialsScreenBankIDMobileView: React.FC<MobileViewProps> = ({
  provider,
  onBack,
  onClickLocal,
  onClickRemote,
  isLoading,
  awaitingScenario,
  paymentDetails,
}) => {
  return (
    <ScreenWrapper data-testid="submit-credentials-screen-bankid-mobile">
      <Header
        addBottomMargin={false}
        onBack={onBack}
        hideCloseButton
        pageView={PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID}
      />

      <ContentBody>
        <Stack justifyContent="center" alignItems="center">
          <BankIdLogo size="110px" px="normedium" py="normedium" mx="auto" my="medium" />
          <H1 mb="small" align="center">
            {awaitingScenario === AwaitingScenario.PAYMENT ? (
              <FormattedMessage {...AwaitingMessages.instructions} />
            ) : (
              <FormattedMessage
                {...AwaitingMessages.connectTitle}
                values={{ providerName: provider.displayName }}
              />
            )}
          </H1>
        </Stack>
        <Footer stickToBottom as="div">
          {paymentDetails && (
            <Box mb="normal" fullWidth>
              {paymentDetails}
            </Box>
          )}
          {isLoading ? (
            <LoadingSpinner data-testid="loading-spinner" />
          ) : (
            <>
              <Button color="primary" onClick={onClickLocal} variant="contained">
                <StyledBankId />
                <FormattedMessage {...AwaitingMessages.openMobileBankId} />
              </Button>
              <Button onClick={onClickRemote}>
                <FormattedMessage {...AwaitingMessages.anotherDevice} />
              </Button>
            </>
          )}
        </Footer>
      </ContentBody>
      <LegalDisclaimer provider={provider} pageView={PageView.SUBMIT_CREDENTIALS_SCREEN_BANKID} />
    </ScreenWrapper>
  );
};
